module.exports = __webpack_public_path__ + "img/desk.1d26e1fd.svg";